<template>
  <div class="flex-box al-c tourist-tab-bar">
    <div class="flex-1 flex-box h100 al-c ju-c font-18 cu-p tourist-tab-bar-item" :class="touristActive == 'student' ? 'active' : null" @click="setActive('student')">
      <img :src="`${baseUrl}images/icon-tab-stu.png`">
      <span class="ml10">学生办事</span>
    </div>
    <div class="flex-1 flex-box h100 al-c ju-c font-18 cu-p tourist-tab-bar-item" :class="touristActive == 'teacher' ? 'active' : null" @click="setActive('teacher')">
      <img :src="`${baseUrl}images/icon-tab-ter.png`">
      <span class="ml10">教师办事</span>
    </div>
    <div class="flex-1 flex-box h100 al-c ju-c font-18 cu-p tourist-tab-bar-item" :class="touristActive == 'tourist' ? 'active' : null" @click="setActive('tourist')">
      <img :src="`${baseUrl}images/icon-tab-tor.png`">
      <span class="ml10">游客</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TouristTabBar",
  components: {},
  props: ["tourist-active"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    setActive(value) {
      this.$emit("set-active", value);
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
.tourist-tab-bar {
  margin: -30px auto 0 auto;
  padding: 0 32px;
  width: 750px;
  height: 64px;
  background: #effafd;
  border-radius: 32px;
  box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.2);
}

.tourist-tab-bar-item:hover {
  background: #dfeff3;
}

.tourist-tab-bar-item.active {
  color: #2e67be;
}
</style>
